function UserForms(form, callback) {
    $.ajax({
        type: form.attr("method"),
        url: form.attr("action"),
        data: form.serialize(),
        dataType: "json",
        cache: false,
        success: function (dt) {
            callback(dt);
        },
        error: function () {
            callback(getStandartMessages("BirHataOlustu"));
        }
    });
}

function AccountAjaxForms(form, callback) {
    $.ajax({
        type: form.attr("method"),
        url: form.attr("action"),
        data: form.serialize(),
        dataType: 'json',
        cache: false,
        success: function (data) {
            callback(data.Sonuc, data.IslemSonucAciklama);
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

function MyOrderNotMember(form) {
    $.ajax({
        type: form.attr("method"),
        url: form.attr("action"),
        data: form.serialize(),
        success: function (data) {

            $("#UserOrderModal").modal("show");
            $("#UserOrderModal").find(".modal-body").html(data);

            $("iframe").css("height", $("iframe").height() + 500);

            GenerateLocalLoading(form, "hide");
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            GenerateLocalLoading(form, "hide");
        }
    });
}

function DeleteFollowItem(ID, langID, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Cart/RemoveFromList",
        data: 'id=' + ID + "&langID=" + langID,
        contentType: "application/json; charset=utf-8",
        dataType: 'json',
        success: function (dt) {
            callback(dt.Sonuc, dt.IslemSonucAciklama);
        },
        error: function () {
            callback(false, getStandartMessages("BirHataOlustu"));
        }
    });
}

// #region Orders
function GetUserOrderDetails(Url, callback) {
    $.ajax({
        type: 'GET',
        url: Url,
        cache: false,
        success: function (data) {
            callback(data);
        }
    });
}

function GetRetOrdersForm(orderedItemsID, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Orders/RetOrder",
        data: 'OrderedItemID=' + orderedItemsID,
        success: function (data) {
            callback(true, data);
        },
        error: function () {
            callback(false, getStandartMessages("TalebinizYerineGetirilirkenBirHataOlustuLutfenDaha"));
        }
    });
}

function GetMoneyTransferInfoForm(trackCode, callback) {
    $.ajax({
        type: 'GET',
        url: getRequestRoute() + "/p/Orders/MoneyTransferInfo",
        data: 'TrackCode=' + trackCode,
        success: function (data) {
            callback(true, data);
        },
        error: function () {
            callback(false, getStandartMessages("TalebinizYerineGetirilirkenBirHataOlustuLutfenDaha"));
        }
    });
}
// #endregion

// #region Address
function GetAddressList() {
    GenerateLocalLoading($(".AdresFieldSet .MyAddress"), "show");

    $.ajax({
        type: 'GET',
        url: getRequestRoute() + '/p/User/AdressInfo',
        data: "language=" + $("#SmallLangCode").val(),
        success: function (data) {
            $(".UserPage .AccountRight .PageBodyContainer .MyAddress").html(data);
            GenerateLocalLoading($(".UserPage .AccountRight .PageBodyContainer .MyAddress"), "hide");
        },
        error: function () {
            GenerateLocalLoading($(".UserPage .AccountRight .PageBodyContainer .MyAddress"), "hide");
        }
    });
}

function GetPartialAdress(AddressModal, EditLink) {
    if (EditLink == "" || EditLink == null || EditLink == undefined) {
        EditLink = getRequestRoute() + "/p/User/PartialAdressAdd";
        AddressModal.find(".modal-header > .edit").hide();
        AddressModal.find(".modal-header > .create").show();
    }
    else {
        AddressModal.find(".modal-header > .edit").show();
        AddressModal.find(".modal-header > .create").hide();
    }

    $.ajax({
        type: "GET",
        url: EditLink,
        success: function (data) {
            AddressModal.find(".modal-body").html(data);

            if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "TR"
                || $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "KKTC") { // TR
                $(".tr_group").show();
                $(".stateDiv").hide();
                $(".cityDiv").hide();
            }

            if (($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "TR"
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "KKTC")
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "CA"
                &&
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") != "US") { //Rest of world

                $(".tr_group").hide();
                $(".stateDiv").hide();
                $(".cityDiv").show();
            }

            if ($(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "CA"
                ||
                $(".ddl_ulke option[value='" + $(".ddl_ulke").val() + "']").attr("data-code") == "US") { //USA & CA

                $(".tr_group").hide();
                $(".stateDiv").show();
                $(".cityDiv").show();
            }

            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            AddressModal.modal("hide");
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        }
    });
}

function GetDistrict(CityID) {
    $.ajax({
        type: 'get',
        url: getRequestRoute() + '/p/User/GetTowns',
        data: 'cityid=' + CityID,
        dataType: 'json',
        success: function (dt) {
            $('#district option').remove();

            $('#district')
                .append($("<option selected='selected' ></option>")
                    .attr("value", "")
                    .text(getStandartMessages("LutfenSecin")));

            $('#district').parent().find("span").html(getStandartMessages("LutfenSecin"));

            for (var i = 0; i < dt.length; i++) {
                $('#district')
                    .append($("<option></option>")
                        .attr("value", dt[i].ID)
                        .text(dt[i].Name));

            }

            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
        },
        error: function () {
            GenerateLocalLoading(AddressModal.find(".modal-dialog"), "hide");
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
        }
    });
}

function DeleteAddress(AddressID, AddressBox) {
    var DeleteUrl = getRequestRoute() + "/p/User/DeleteAdress/" + AddressID;
    GenerateLocalLoading(AddressBox, "show");

    $.ajax({
        type: "POST",
        url: DeleteUrl,
        cache: false,
        success: function (data) {
            if (data == "true") {
                SwalGenerate("success", getStandartMessages("AdresSilindi"), getStandartMessages("IslemBasarili"), getStandartMessages("Kapat"));
                GetAddressList();
            }
            else {
                SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            }

            GenerateLocalLoading(AddressBox, "hide");
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            GenerateLocalLoading(AddressBox, "hide");
        }
    });
}
// #endregion

// #region User Messages
function GetMessageDetail(Url) {
    var Modal = $("#MessageDetailModal");
    Modal.modal("show");
    ModalHideEvent(Modal, ".modal-content");
    GenerateLocalLoading(Modal.find(".modal-dialog"), "show");

    $.ajax({
        type: 'GET',
        url: Url,
        cache: false,
        success: function (data) {
            Modal.find(".modal-content").html(data);
            GenerateLocalLoading(Modal.find(".modal-dialog"), "hide");
        },
        error: function () {
            SwalGenerate("error", getStandartMessages("BirHataOlustu"), getStandartMessages("IslemBasarisiz"), getStandartMessages("TekrarDene"));
            GenerateLocalLoading(Modal.find(".modal-dialog"), "hide");
            setTimeout(function () { Modal.modal("hide"); }, 500);
        }
    });
}

function AddNewUserMessage(form, callback) {
    $.ajax({
        type: form.attr("method"),
        url: form.attr("action"),
        data: form.serialize(),
        cache: false,
        success: function (data) {
            callback(data, true);
        },
        error: function () {
            callback("", false);
        }
    });
}
// #endregion